import Report from './report'

export default interface ReportsList {
    success: boolean
    count: number
    configs: Report[]
}
const defaultReportsList = {
    success: false,
    count: 0,
    configs: []
} as ReportsList

export { defaultReportsList }
